import Vue from 'vue'
import Vuex from 'vuex'

import actions from './actions'
import mutations from './mutations'
import getters from './getters'

import constants from '../constants'
import treeData from '../assets/bomen.json'
import wegvakData from '../assets/wegvakken.json'
import trackerLikesData from '../assets/tracker-likes.json'
import vrLocationData from '../assets/vr/deventer/vr-locations.json'
import anteaMeetplekken from '../assets/antea/deventer/meetplekken.json'
import metricwireShapesDeventer from '../assets/metricwire/deventer/shapes.json'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    navigation: {
      activeTabIndex: null,
      tabs: [],
      favorites: [],
    },
    data: {
      presets: { system: [], user: [] },
      filter: {
        startDate: null,
        endDate: null,
      },
      currentDate: null,
      events: {
        selectedEventIndex: null,
        geojson: {
          type: 'FeatureCollection',
          features: []
        }
      },
      vr: {
        location: null,
        survey: {}
      },
      traveltime: {
        timeseries: {}
      },
      travelintensity: {
        timeseries: {}
      },
      weather: {
        current:{
          temperature: 0,
          icon: ''
        },
        timeseries: {}
      },
      parking: {
        datasets: {},
        timeseries: {}
      },
      antea: {
        fijnstof: {},
        ultrafijnstof: {},
        thies: {},
        trillingen: {}
      },
      metricwire: {
        surveys: [],
        surveyCategories: [],
        selectedSurvey: {}
      },
      experienceSampling: {
        authToken: null,
        workspace: {
          id: null,
          studies: [],
          selectedStudy: {
            id: null,
            surveys: [],
            selectedSurvey: {
              id: null,
              questions: [],
              selectedQuestion: null,
            }
          }
        },
        chart: {
        }
      }
    },
    pager: {
      trackerroutes: {
        selectedIndex: 0,
        data: []  // A collection of GeoJSON feature collections.
      }
    },
    map: {
      bounds: { ne: null, sw: null },
      controls: {
        layers: [
          { id: constants.MAP_LAYER_TREES_ID, name: 'Bomen', group: 'Interventies', visible: false},
          { id: constants.MAP_LAYER_EVENT_ID, name: 'Evenementen', group: 'Interventies', visible: true },
          { id: constants.MAP_LAYER_WEATHER_ID, name: 'Weer', group: 'Interventies', visible: true },
          { id: constants.MAP_LAYER_TRAFFIC_ID, name: 'Drukte kruispunten', group: 'Bezoekersaantallen', visible: true },
          { id: constants.MAP_LAYER_PARKING_ID, name: 'Parkeergarages', group: 'Bezoekersaantallen', visible: true },
          { id: constants.MAP_LAYER_TRAVEL_ID, name: 'Reistijd', group: 'Bezoekersaantallen', visible: true },
          { id: constants.MAP_LAYER_SURVEY_ID, name: 'Experiencesampling', group: 'Bezoekerstevredenheid en -beleving', visible: true },
          { id: constants.MAP_LAYER_TRACKERS_ID, name: 'Trackers', group: 'Bezoekerstevredenheid en -beleving', visible: true,
            items: [
              { id: constants.MAP_LAYER_TRACKERS_HEATMAP_ID, name: 'Heatmap', visible: true },
              { id: constants.MAP_LAYER_TRACKERS_ROUTES_ID, name: 'Routes', visible: true, pager: { max: 0, current: 0} },
              { id: constants.MAP_LAYER_TRACKERS_LIKES, name: 'Likes', visible: true }
            ]
          },
          { id: constants.MAP_LAYER_VR_ID, name: 'VR-enquête', group: 'Bezoekerstevredenheid en -beleving', visible: true },
          // { id: constants.MAP_LAYER_ANTEA_ID, name: 'Antea', visible: false },
        ]
      },
      data: {
        update: false,
        layers: [{
          id: constants.MAP_LAYER_TRAVEL_ID,
          type: 'line',
          source: {
            type: 'geojson',
            data: wegvakData
          },
          paint: {
            'line-width': 2,
            // 'line-color': '#2c3e50'
            // 'line-color': '#009900'
            'line-color': [
              'step',
              ['get', 'relativeDelay'],
              '#999999',
              0.5,
              '#24d681',
              1.0,
              '#f6bb2c',
              2.0,
              '#ed706d'
            ]
          }
        },{
          id: constants.MAP_LAYER_TREES_ID,
          type: 'circle',
          source: { type: 'geojson', data: treeData },
          paint: {
            'circle-color': 'hsla(141, 71%, 48%, 0.7)',
            'circle-radius': 3
          }
        },{
          id: constants.MAP_LAYER_TRACKERS_HEATMAP_ID,
          type: 'heatmap',
          source: {
            type: 'geojson',
            data: {
              type: 'FeatureCollection',
              features: []
            }
          },
          paint: {
            'heatmap-radius': [
              'interpolate',
              ['linear'],
              ['zoom'],
              0, 2,
              9, 20
            ],
            'heatmap-opacity': 0.5
          }
        },{
          id: constants.MAP_LAYER_TRACKERS_ROUTES_ID,
          type: 'line',
          source: {
            type: 'geojson',
            data: {
              type: 'FeatureCollection',
              features: []
            }
          },
        },{
          id: constants.MAP_LAYER_TRACKERS_LIKES,
          type: 'circle',
          source: { type: 'geojson', data: trackerLikesData },
          paint: {
            'circle-color': 'hsla(357, 92%, 41%, 0.7)',
            'circle-radius': 3
          }
        },{
          id: constants.MAP_LAYER_SURVEY_ID,
          type: 'fill',
          source: { type: 'geojson', data: metricwireShapesDeventer },
          paint: {
            'fill-color': 'hsla(0°, 0%, 60%, 0.5)',
            'fill-outline-color': 'hsla(0°, 0%, 60%, 0.9)'
          }
        },{
          id: constants.MAP_LAYER_VR_ID,
          type: 'symbol',
          source: { type: 'geojson', data: vrLocationData },
          layout: {
            'icon-image': constants.VR_MARKER_IMAGE_ID,
            'icon-allow-overlap': true,
            'icon-size': 0.5,
            'text-font': ['Open Sans Semibold', 'Arial Unicode MS Bold'],
            'text-offset': [0, 0.6],
            'text-anchor': 'top'
          }
        },{
          id: constants.MAP_LAYER_ANTEA_ID,
          type: 'symbol',
          source: { type: 'geojson', data: anteaMeetplekken},
          layout: {
            'icon-image': constants.ANTEA_MARKER_IMAGE_ID,
            'icon-allow-overlap': true,
            'icon-size': 0.5,
            'text-font': ['Open Sans Semibold', 'Arial Unicode MS Bold'],
            'text-offset': [0, 0.6],
            'text-anchor': 'top'
          }
        },{
          id: constants.MAP_LAYER_EVENT_ID,
          type: 'symbol',
          source: {
            type: 'geojson',
            data: {
              type: 'FeatureCollection',
              features: []
            }
          },
          layout: {
            'icon-image': constants.EVENT_MARKER_IMAGE_ID,
            'icon-allow-overlap': true,
            'icon-size': 0.5,
            'text-font': ['Open Sans Semibold', 'Arial Unicode MS Bold'],
            'text-offset': [0, 0.6],
            'text-anchor': 'top'
          }
        },{
          id: constants.MAP_LAYER_PARKING_ID,
          type: 'symbol',
          source: {
            type: 'geojson',
            data: {
              type: 'FeatureCollection',
              features: []
            }
          },
          layout: {
            'icon-image': 'car-15',
            'icon-allow-overlap': true,
            'text-field': '{occupiedPercentage} %',
            'text-font': ['Open Sans Semibold', 'Arial Unicode MS Bold'],
            'text-offset': [0, 0.6],
            'text-anchor': 'top'
          }
        },{
          id: constants.MAP_LAYER_TRAFFIC_ID,
          type: 'circle',
          source: {
            type: 'geojson',
            data: {
              type: 'FeatureCollection',
              features: []
            }
          },
          paint: {
            'circle-color': 'hsla(240, 51%, 32%, 0.7)',
            'circle-radius': ['sqrt', [
              '/', ['number', ['get', 'eventCount']], 1000]
            ],
          },
        }]
      },
    },
  },
  actions: actions,
  mutations: mutations,
  getters: getters,
})
